export default {
  '上海松江区爱菊学校': '上海松江区爱菊学校',
  '地址': '地址：上海市松江区文俊东路100号',
  '小初': '小初：18017147170',
  '高中': '高中：18621521084',
  '爱菊教育': '爱菊教育',
  '新闻与活动': '新闻与活动',
  '查看更多': '查看更多',
  '联系我们': '联系我们',
  '关于我们': '关于我们',
  '期待': '期待各位家长和学生到来',
  '小初部联系': '小初部联系：18017147170',
  '高中部联系': '高中部联系：18621521084',
  '小初公众号二维码': '小初公众号二维码',
  '高中公众号二维码': '高中公众号二维码',
  '探索更多': '探索更多',
};
